<template>
<div>
  <div class="wistia_embed wistia_async_392vtvyb2k">
    &nbsp;
  </div>

  <span
    id="vid-embeds-6-3"
    class="tbk-vid-embed"
  >
    <a
      id="pharmacist"
      class="embedded_video"
      href="#wistia_um38b1ngw5?videoFoam=true"
    >
      &nbsp;
    </a>
    <br>

    <a
      id="nutritionist"
      class="embedded_video"
      href="#wistia_yzjqyuhn3m?videoFoam=true"
    >
      &nbsp;
    </a>
    <br>

    <a
      id="mental-health"
      class="embedded_video"
      href="#wistia_p33p85zj8r?videoFoam=true"
    >
      &nbsp;
    </a>
    <br>

    <a
      id="physician"
      class="embedded_video"
      href="#wistia_dzxj3pgtih?videoFoam=true"
    >
      &nbsp;
    </a>
    <br>

    <a
      id="nurse"
      class="embedded_video"
      href="#wistia_j6nr7mghi7?videoFoam=true"
    >
      &nbsp;
    </a>
    <br>
  </span>
</div>
</template>

<script>
import TbkVideoMixin from './TbkVideoMixin'

export default {
  mixins: [TbkVideoMixin],

  mounted() {
    this.tbk.loadCrossTime('392', 90, this.showSelect)
    this.tbk.loadCrossTime('um3', 37, this.showSelect)
    this.tbk.loadCrossTime('yzj', 27, this.showSelect)
    this.tbk.loadCrossTime('p33', 41, this.showSelect)
    this.tbk.loadCrossTime('dzx', 51, this.showSelect)
    this.tbk.loadCrossTime('j6n', 21, this.showSelect)

    if (this.tbk.isMobile()) {
      _wq.push({
        um3: this.tbk.autoPlay,
        yzj: this.tbk.autoPlay,
        p33: this.tbk.autoPlay,
        dzx: this.tbk.autoPlay,
        j6n: this.tbk.autoPlay
      })
    }
  },

  methods: {
    showSelect() {
      $('.tbk-vid-embed').show()
      this.tbk.hideMobileControls()
    }
  }
}
</script>

<style scoped lang="sass">
#vid-embeds-6-3
  display: none
  background-image: url('~./diabetes-6_3.jpg')
  a
    text-decoration: none
    &:link
      &.embedded_video
        -moz-border-radius: 10px
        -webkit-border-radius: 10px
        border-radius: 10px
    &:hover
      &.embedded_video
        background-color: rgba(255, 255, 255, 0.2)
#pharmacist
  position: absolute
  top: calc(100% * (20 / 360))
  left: calc(100% * (80 / 640))
  width: calc(100% * (125 / 640))
  height: calc(100% * (145 / 360))
#nutritionist
  position: absolute
  top: calc(100% * (20 / 360))
  left: calc(100% * (258 / 640))
  width: calc(100% * (125 / 640))
  height: calc(100% * (145 / 360))
#mental-health
  position: absolute
  top: calc(100% * (20 / 360))
  left: calc(100% * (430 / 640))
  width: calc(100% * (125 / 640))
  height: calc(100% * (160 / 360))
#physician
  position: absolute
  top: calc(100% * (170 / 360))
  left: calc(100% * (165 / 640))
  width: calc(100% * (125 / 640))
  height: calc(100% * (165 / 360))
#nurse
  position: absolute
  top: calc(100% * (180 / 360))
  left: calc(100% * (345 / 640))
  width: calc(100% * (115 / 640))
  height: calc(100% * (150 / 360))

@media (max-width: 450px)
  #pharmacist,
  #nutritionist,
  #mental-health,
  #physician,
  #nurse
    font-size: 12px
    padding-top: 6px
    padding-bottom: 6px
</style>
